import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=f8e72ea8&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=f8e72ea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e72ea8",
  null
  
)

export default component.exports